module.exports = __webpack_public_path__ + "img/circle_downloaded.ab99bee9.png";